
  import React from "react"
  import Component from "/Users/diljith/Workspace/Gatsby/StaticSite/livshutz/src/layouts/index.js"
  import data from "/Users/diljith/Workspace/Gatsby/StaticSite/livshutz/.cache/json/layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js